module.exports = __webpack_public_path__ + "static/media/oman-new-logo.30dc467a.svg";